// context/SettingsContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { setting_api } from '../api/PageApi';


const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loadingg, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const data = await setting_api();
        setSettings(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loadingg, error }}>
      {children}
    </SettingsContext.Provider>
  );
};

// Custom hook for easy access
export const useSettings = () => useContext(SettingsContext);
